import MuiInputLabel from '@mui/material/InputLabel';
import type { ComponentPropsWithoutRef, ComponentRef } from 'react';
import { forwardRef } from 'react';

type InputLabelProps = ComponentPropsWithoutRef<typeof MuiInputLabel>;
type InputLabelRef = ComponentRef<typeof MuiInputLabel>;

const InputLabel = forwardRef<InputLabelRef, InputLabelProps>((props, ref) => {
  return <MuiInputLabel ref={ref} {...props} />;
});
InputLabel.displayName = 'InputLabel';
export default InputLabel;
